import React, { useEffect } from "react";
import { useNavigate, Link, Outlet } from "react-router";
import { Container, Navbar, Nav, Image, NavDropdown } from "react-bootstrap";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser,
    faRightFromBracket,
    faCircleUp,
} from "@fortawesome/free-solid-svg-icons";
import brandIcon from "assets/images/icon.png";
import { useAuth } from "components/shared/AuthProvider";
import ThemeToggle from "components/shared/ThemeToggle";
import Footer from "components/shared/Footer";
import user_portrait_placeholder from "assets/images/user_portrait_placeholder.png";
import Seo from "components/shared/Seo";

const ProfilePic = styled(Image)`
    width: 2rem;
`;

const AuthenticatedLayout = () => {
    const { logout, user } = useAuth();
    const nav = useNavigate();

    useEffect(() => {
        if (user?.id_provider === "WISHLIZ" && user?.is_confirmed === false) {
            nav("account/inactive-account");
        }
    }, [nav, user]);

    return (
        <div className="d-flex flex-column min-vh-100">
            {/* Baseline SEO defaults; pages render their own Seo to override per-route values */}
            <Seo />
            <Navbar
                variant="dark"
                bg="dark"
                expand="lg"
                sticky="top"
                collapseOnSelect={true}
            >
                <Container>
                    <Navbar.Brand
                        href="/"
                        className="d-flex align-items-center"
                    >
                        <img
                            alt=""
                            src={brandIcon}
                            width="30"
                            height="30"
                            className="d-inline-block"
                        />{" "}
                        Wishliz
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="#" as={Link} to="/dashboard">
                                Dashboard
                            </Nav.Link>
                            <Nav.Link href="#" as={Link} to="/wishlist">
                                Wishlist
                            </Nav.Link>
                            <Nav.Link href="#" as={Link} to="/help">
                                Help
                            </Nav.Link>
                            <Nav.Link href="#" as={Link} to="/help/mcp">
                                MCP
                            </Nav.Link>
                        </Nav>

                        <Nav>
                            <Nav.Item className="me-2 d-flex align-items-center">
                                <ThemeToggle />
                            </Nav.Item>
                            <NavDropdown
                                title={
                                    <ProfilePic
                                        src={
                                            user.picture_url ??
                                            user_portrait_placeholder
                                        }
                                        referrerPolicy="no-referrer"
                                        roundedCircle
                                    />
                                }
                                menuVariant="dark"
                            >
                                <NavDropdown.Item
                                    href="#"
                                    onClick={() => nav("/account")}
                                >
                                    <FontAwesomeIcon icon={faUser} /> Profile
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    href="#"
                                    onClick={() =>
                                        nav("/subscription/pricing/upgrade")
                                    }
                                >
                                    <FontAwesomeIcon icon={faCircleUp} />{" "}
                                    Upgrade
                                </NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item
                                    href="#"
                                    as={Link}
                                    onClick={logout}
                                >
                                    <FontAwesomeIcon
                                        icon={faRightFromBracket}
                                    />{" "}
                                    Sign Out
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Outlet />
            <Footer />
        </div>
    );
};

export default AuthenticatedLayout;
